import { ReduxAction, setAsyncData } from '../core';

import { FeeSchedule } from './types';
import { FeeScheduleAction } from './actions';
import { FeeScheduleState } from './types';

const initialState: FeeScheduleState = {
  feeScheduleList: { isFetching: false },
};

export function feeScheduleReducer(state: FeeScheduleState = initialState, action: ReduxAction<any>): FeeScheduleState {
  switch (action.type) {
    case FeeScheduleAction.SET_FEE_SCHEDULE_DATA_FETCHING:
      return {
        ...state,
        feeScheduleList: setAsyncData(state.feeScheduleList, (v) => (v.isFetching = action.data as boolean)),
      };
    case FeeScheduleAction.FEE_SCHEDULE_RECEIVED:
      // can i merge it into the list?
      let merged = false;
      const newList: FeeSchedule[] = (state.feeScheduleList.data || []).map((fs: FeeSchedule) => {
        if (fs.id === action.data.id) {
          merged = true;
          return action.data;
        } else {
          return fs;
        }
      });
      return {
        ...state,
        feeScheduleList: setAsyncData(state.feeScheduleList, (v) => {
          v.data = merged ? newList : [action.data].concat(state.feeScheduleList.data);
        }),
      };
    case FeeScheduleAction.SET_FEE_SCHEDULE_DATA:
      return {
        ...state,
        feeScheduleList: setAsyncData(state.feeScheduleList, (v) => (v.data = action.data as FeeSchedule[])),
      };
    case FeeScheduleAction.SET_BILLING_PROVIDER_ID:
      return {
        ...state,
        billingProviderId: action.data,
      };
    case FeeScheduleAction.SET_PAYER_ID:
      return {
        ...state,
        payerId: action.data,
      };
    case FeeScheduleAction.SET_CPT_SEARCH:
      return {
        ...state,
        cptSearch: action.data,
      };
    default:
      return state;
  }
}
